import React from 'react'
import { ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native'
import { Paragraph, useTheme } from 'react-native-paper'
import { useDispatch, useSelector } from 'react-redux'

import CheckCard from 'components/CheckCard'

const selector = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  selector: {
    padding: 3,
    paddingVertical: 12,
    borderColor: 'green',
    borderWidth: 3,
    borderRightWidth: 0,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  selected: {
    backgroundColor: 'green',
  },
  selectorStart: {
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
  },
  selectorEnd: {
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    borderRightWidth: 3,
  },
})

const Section = ({ title, children }) => {
  return (
    <View style={styles.section}>
      <Paragraph style={styles.sectionTitle}>{title}</Paragraph>
      {children}
    </View>
  )
}

const Selector = ({ title, values, selected, onPress }) => {
  const { colors } = useTheme()

  return (
    <Section title={title}>
      <View style={selector.container}>
        {values.map((value, index) => (
          <TouchableOpacity
            key={index}
            onPress={() => onPress(value)}
            style={[
              selector.selector,
              { borderColor: colors.primary },
              value == selected && { backgroundColor: colors.primary },
              index == 0 && selector.selectorStart,
              index == values.length - 1 && selector.selectorEnd,
            ]}
          >
            <Paragraph>{value}</Paragraph>
          </TouchableOpacity>
        ))}
      </View>
    </Section>
  )
}

const DIETARY = [
  ['Vegetarian', 'VEGETARIAN'],
  // TODO: switch these on when we have more recipes to work with
  // ['Dairy Free', 'DAIRY_FREE'],
  // ['Gluten Free', 'GLUTEN_FREE'],
  // ['Ketogenic', 'KETOGENIC'],
  // ['Paleo', 'PALEOLITHIC'],
]

const Settings = () => {
  const dispatch = useDispatch()
  const { servings, meals, diet } = useSelector(({ settings }) => settings)

  return (
    <ScrollView
      style={{ width: '100%', backgroundColor: '#132936', padding: 10 }}
    >
      <Selector
        title="Number of meals"
        values={[1, 2, 3, 4, 5]}
        selected={meals}
        onPress={(meals) => dispatch({ type: 'SET_MEALS', meals })}
      />

      <Selector
        title="Number of servings"
        values={[1, 2, 3, 4, 5]}
        selected={servings}
        onPress={(servings) => dispatch({ type: 'SET_SERVINGS', servings })}
      />

      <Section title="Dietary Requirements">
        {DIETARY.map(([title, value]) => (
          <CheckCard
            key={value}
            title={title}
            checked={diet.includes(value)}
            onPress={() =>
              dispatch({
                type: 'TOGGLE_DIETARY_REQUIREMENT',
                requirement: value,
              })
            }
          />
        ))}
      </Section>
    </ScrollView>
  )
}
const styles = StyleSheet.create({
  section: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontSize: 18,
    marginBottom: 10,
  },
})

export default Settings
